"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Modal = require("@ccw-pwa-ui/Modal");
var _Input = require("@ccw-pwa-ui/Input");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
var _Button = require("@ccw-pwa-ui/Button");
var _react = _interopRequireDefault(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _images = require("../common_features/assets/images");
var _hi = require("react-icons/hi");
var _fa = require("react-icons/fa");
var _ai = require("react-icons/ai");
var _Image = require("@ccw-pwa-ui/Image");
var _DataTable = require("@ccw-pwa-ui/DataTable");
require("../styles/StoreDetailsComponent.scss");
const StoreDetailsComponent = props => {
  var _props$rowSelect, _props$allSelect, _props$rowSelect2, _props$rowSelect3, _props$selectedFilter, _props$selectedFilter2;
  const {
    sName,
    countries,
    zipcode,
    isZipCodeValid,
    address1,
    address2,
    city,
    state,
    phoneNo,
    setSName,
    setCountry,
    setZipcode,
    setAddress1,
    setAddress2,
    setCity,
    setState,
    setPhoneNo,
    title,
    country,
    isFormValid,
    setSearch,
    query,
    userModal,
    setUserModal,
    handleModal,
    isEditable,
    count,
    handleSubmit,
    setSearch2,
    isLoading,
    backBtn,
    pageSize,
    userType
  } = props;
  const {
    code
  } = country;
  const getButtonStyle = () => {
    return props.edit ? /*#__PURE__*/_react.default.createElement(_Button.Button, {
      disabled: !isFormValid(),
      variant: "primary",
      title: "Save",
      buttonStyle: {
        marginRight: 0,
        cursor: 'pointer'
      },
      onClick: props.updateCurrentStore
    }) : /*#__PURE__*/_react.default.createElement(_Button.Button, {
      variant: "primary-long",
      icon: /*#__PURE__*/_react.default.createElement(_Image.Image, {
        url: _images.whitePencil.default
      }),
      onClick: () => props.setEdit(!props.edit),
      title: "Edit Store",
      buttonStyle: {
        marginRight: 0,
        cursor: 'pointer',
        color: "white"
      }
    });
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "px-4"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: props.ModalVarient,
    modalHeaderText: props.modalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px"
    },
    modalDetailText: props.modalDetailText,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px"
    },
    displayModal: props.removeUserModal,
    positiveActionButtonTitle: props.positiveActionButtonTitle,
    negativeButtonActionTitle: props.negativeButtonActionTitle,
    positiveAction: props.handleResendInviteModal,
    negativeAvtion: props.handleSetReInviteCancelModal,
    variantBtn1: "outline-primary-long",
    variantBtn2: "nav-link-button",
    wrapperStyle: {
      borderRadius: "12px 12px 12px 12px"
    },
    btn1Style: {
      color: "#E00932",
      borderColor: "#E00932",
      fontFamily: "Poppins"
    },
    btn2Style: {
      width: '100%',
      justifyContent: "center"
    }
  }), /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variantBtn1: "primary-long",
    customIcon: props.customIcon,
    variantBtn2: "nav-link-button",
    btn2Style: {
      width: '100%',
      justifyContent: "center"
    },
    variant: props.ErrorModalVariant,
    modalHeaderText: props.ErrorModalHeaderText,
    modalHeaderTextStyle: {
      fontSize: 20,
      color: '#333333',
      fontWeight: 600,
      lineHeight: "25px",
      fontFamily: "Poppins"
    },
    modalDetailText: props.ErrorModalDetailText,
    modalDetailText2: props.ErrorModalDetailText2,
    modalDetailTextStyle: {
      fontSize: 16,
      color: '#333333',
      fontWeight: 400,
      lineHeight: "22px",
      fontFamily: "Poppins"
    },
    displayModal: props.errorModal,
    positiveActionButtonTitle: props.positiveActionErrorButtonTitle,
    negativeButtonActionTitle: props.negativeErrorButtonActionTitle,
    positiveAction: props.handleErrorModal,
    negativeAvtion: props.handleErrorCancelModal
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex flex-column align-items-start  p-0 pt-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  fieldContainer store-details-heading"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between system-add-btn"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Manage Store >",
    variant: "simple-text",
    headerStyle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#333333',
      lineHeight: '18px'
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: props.storeState.sName,
    variant: "simple-text",
    headerStyle: {
      fontSize: 12,
      fontWeight: 400,
      color: '#9a9a9a',
      lineHeight: '18px',
      marginLeft: 8
    }
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  justify-content-between py-2 align-items-center editStoreBtn-style"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row align-items-center storeNameDiv-Text",
    "data-testid": "BackBTN"
  }, backBtn && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "nav-link-button",
    title: "",
    buttonStyle: {
      width: '100%',
      justifyContent: 'center',
      fontSize: 27
    },
    icon: /*#__PURE__*/_react.default.createElement(_hi.HiChevronLeft, {
      style: {
        width: 40,
        height: 40
      }
    }),
    onClick: props.navigateToManageStore
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "".concat(props.viewHeaderText, " ").concat(props.storeState.sName),
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "desktop-system-btn"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    disabled: false,
    variant: "primary-long",
    onClick: props.handleSystemBtn,
    title: "Go to Systems",
    buttonStyle: {
      backgroundColor: "#FFFFFF",
      color: "#006E96",
      borderColor: "#006E96"
    }
  })), isEditable ? getButtonStyle() : null)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row justify-content-between align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "store-image-div-web",
    onClick: props.zoomImageAction
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "store-image-img",
    src: props.storeImage,
    alt: "",
    style: props.storeImageStyle,
    onClick: props.zoomImageAction,
    "data-testid": "store-image-div"
  })))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 7
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: false,
    headerProps: {
      disabled: !props.edit,
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Store Name"
    },
    inputProps: {
      disabled: !props.edit,
      value: sName,
      placeholder: "Enter Store Name",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px"
      },
      onchange: setSName,
      suffix: ""
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: ""
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 5
  }, " ", /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Store Phone Number",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    disabled: !props.edit,
    disableDropdown: true,
    placeholder: "Enter Store Phone Number",
    countryCodeEditable: false,
    Countries: countries,
    onlyCountries: ['us'],
    inputType: "phone-input",
    dynamicTitleStyle: {
      color: '#333333',
      fontSize: 16
    },
    value: phoneNo,
    onchange: setPhoneNo,
    country: code || 'us',
    phoneNumberInputClass: "".concat(!props.edit ? "phone-input-disabled" : "phone-input1")
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: true
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: false,
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Address 1"
    },
    inputProps: {
      disabled: !props.edit,
      value: address1,
      placeholder: "Enter Address 1",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px"
      },
      onchange: setAddress1,
      suffix: null
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: ""
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, null, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: false,
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Address 2"
    },
    inputProps: {
      disabled: !props.edit,
      value: address2,
      placeholder: "Enter Address 2",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px"
      },
      onchange: setAddress2,
      suffix: null
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: ""
    }
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: false,
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "City"
    },
    inputProps: {
      disabled: true,
      value: city,
      placeholder: "Enter City",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px"
      },
      onchange: setCity,
      suffix: null
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: ""
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 6,
    md: 2
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: false,
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "State"
    },
    inputProps: {
      disabled: true,
      value: state,
      placeholder: "Enter State",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px"
      },
      onchange: setState,
      suffix: null
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: ""
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    sm: 6,
    md: 2
  }, /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "lable-input-error",
    isErrorFree: !isZipCodeValid,
    headerProps: {
      headerStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 600,
        lineHeight: "22px"
      },
      variant: "header-text",
      headerText: "Zipcode"
    },
    inputProps: {
      disabled: !props.edit,
      value: zipcode,
      placeholder: "Enter Zipcode",
      inputStyle: {
        fontSize: 16,
        color: '#333333',
        fontWeight: 400,
        lineHeight: "24px"
      },
      onchange: setZipcode,
      suffix: null
    },
    errorProps: {
      headerStyle: {
        fontSize: 12,
        color: '#FF2D55',
        marginBottom: 0
      },
      variant: "header-text",
      headerText: "Enter valid Zipcode"
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    md: 4
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Country",
    variant: "simple-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 600,
      color: '#333333',
      lineHeight: '22px'
    }
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown, {
    "data-testid": "countryDD",
    className: props.edit ? "" : "ant-input-affix-wrapper-disabled"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Toggle, {
    variant: "success",
    id: "dropdown-basic",
    disabled: !props.edit
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: "#000000"
    }
  }, title)), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Menu, null, countries.map(Item => /*#__PURE__*/_react.default.createElement(_reactBootstrap.Dropdown.Item, {
    key: Item.key,
    onClick: () => {
      setCountry(Item);
    }
  }, Item.title)))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex flex-column align-items-start  p-0 pt-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  fieldContainer px-4"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  justify-content-between py-2 align-items-center userTaggingBtn"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Store Access List",
    variant: "header-text",
    headerStyle: {
      fontSize: 27,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "34px"
    }
  })), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: "primary-long",
    icon: /*#__PURE__*/_react.default.createElement(_fa.FaPlus, null),
    title: "Add ".concat(userType === 4 ? "Employee" : "Technician", " to Store"),
    buttonStyle: {
      marginRight: 0
    },
    onClick: handleModal
  }))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, {
    className: "d-flex flex-column align-items-start  p-0 pt-4"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  fieldContainer px-4"
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    className: " align-items-center"
  }, props.searchedData === null && count === 0 ? /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "No ".concat(userType === 4 ? "Employees" : "Technicians", " have access to this store."),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      fontWeight: 400,
      color: 'black',
      lineHeight: "22px",
      marginRight: 10
    }
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    title: "Add ".concat(userType === 4 ? "an Employee" : "a Technician"),
    variant: "nav-link-button",
    className: "",
    buttonStyle: {},
    onClick: handleModal
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between align-items-center abc"
  }, (_props$rowSelect = props.rowSelect) !== null && _props$rowSelect !== void 0 && _props$rowSelect.length || (_props$allSelect = props.allSelect) !== null && _props$allSelect !== void 0 && _props$allSelect.length ? /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "resend-btn-header",
    onClick: props.handleRemoveUserModal
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: /*#__PURE__*/_react.default.createElement(_ai.AiFillDelete, {
      style: {
        fontSize: 16,
        color: '#E00932',
        fontWeight: 700,
        lineHeight: "24px"
      }
    }),
    variant: "header-text",
    headerStyle: {
      fontSize: 20,
      fontWeight: 200,
      lineHeight: "34px",
      marginRight: "2px"
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Remove ".concat(userType === 4 ? "".concat(((_props$rowSelect2 = props.rowSelect) === null || _props$rowSelect2 === void 0 ? void 0 : _props$rowSelect2.length) <= 1 ? "Employee" : "Employees") : "".concat(((_props$rowSelect3 = props.rowSelect) === null || _props$rowSelect3 === void 0 ? void 0 : _props$rowSelect3.length) <= 1 ? "Technician" : "Technicians"), " from Store"),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#E00932',
      fontWeight: 700,
      lineHeight: "24px",
      cursor: "pointer "
    }
  })) : /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "".concat(count, " ").concat(userType === 4 ? "".concat(count <= 1 ? "Employee" : "Employees") : "".concat(count <= 1 ? "Technician" : "Technicians"), " can view this store."),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#9A9A9A',
      fontWeight: 400,
      lineHeight: "22px",
      marginTop: 10
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    onKeyPress: props.handleOnKeyPress1,
    inputType: "filter-search-box",
    inputStyle: {
      width: "500px",
      height: "50px",
      display: "flex",
      margin: "10px auto"
    },
    inputProps: {
      placeholder: "Search Access List",
      inputVal: query,
      disabled: props.disabled,
      onchange: props.setQuery,
      suffix: /*#__PURE__*/_react.default.createElement(_ai.AiOutlineSearch, {
        "data-testid": "suffix",
        style: query ? {
          fontSize: 20,
          color: '#333333',
          cursor: "pointer"
        } : {
          fontSize: 16,
          color: '#9A9A9A'
        },
        onClick: setSearch
      }),
      inputStyle: {
        width: '325px'
      }
    },
    selectProps: {
      itemClick: props.setSelectedFilter,
      selectedItem: ((_props$selectedFilter = props.selectedFilter) === null || _props$selectedFilter === void 0 ? void 0 : _props$selectedFilter.value) || "Select",
      placeholder: "Please select filter",
      dropdownList: props.dropdownList1,
      inputStyle: {
        width: '300px'
      }
    }
  })), /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    checkboxPosition: "left",
    isLoading: props.isDataLoading,
    allowRowClick: props.allowRowClick,
    handleRowClick: props.handleRowClick,
    headerSchema: props.headerSchema,
    bodySchema: props.bodySchemaAsignedUser,
    handleAllRowSelected: props.setAllSelected,
    allRowSelected: props.allSelect,
    rowSelectedList: props.rowSelect,
    handleRowSelect: props.setRowSelected,
    paginationProps: {
      totalLength: count,
      currentPage: props.currentPage,
      pageSize: pageSize,
      handlePageChange: props.handlePageChange,
      paginationStyle: {
        float: "right"
      }
    },
    loadingDataProps: {
      headingTitle: "Loading",
      headerDesc: "Please wait while we fetch records..."
    },
    noDataProps: {
      headingTitle: "No Results Found",
      headerDesc: "Try adjusting your search to find what you’re looking for."
    }
  })))), userModal ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "fixed",
      display: "flex",
      top: 0,
      left: 0,
      zIndex: 100,
      width: "100vw",
      height: "100vh",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: "absolute",
      width: "100%",
      zIndex: -1,
      height: "100%",
      opacity: 0.8,
      backgroundColor: "#0B3471"
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "modal-with-table",
    style: {
      width: "675px",
      height: "635px",
      backgroundColor: "#ffffff",
      borderRadius: '8px',
      padding: "20px"
    },
    "data-testid": "modal-table"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    className: "d-flex p-3 flex-column"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Store Access List",
    variant: "header-text",
    headerStyle: {
      fontSize: 32,
      color: '#0B3471',
      fontWeight: 600,
      lineHeight: "42px"
    }
  }), /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerText: "Add ".concat(userType === 4 ? "Employees" : "Technicians", " who can access this store"),
    variant: "header-text",
    headerStyle: {
      fontSize: 16,
      color: '#000000',
      fontWeight: 400,
      lineHeight: "22px",
      marginTop: 10
    }
  }), /*#__PURE__*/_react.default.createElement(_Input.Input, {
    inputType: "filter-search-box",
    inputStyle: {
      width: "600px",
      height: "50px",
      display: "flex",
      margin: "10px auto"
    },
    onKeyPress: props.handleOnKeyPress2,
    inputProps: {
      placeholder: "Search Access List",
      inputVal: props.setQuery2,
      onchange: props.setQuery2,
      disabled: props.searchDisabled,
      suffix: /*#__PURE__*/_react.default.createElement(_ai.AiOutlineSearch, {
        "data-testid": "suffix",
        style: props.query2 ? {
          fontSize: 20,
          color: '#333333',
          cursor: "pointer"
        } : {
          fontSize: 16,
          color: '#9A9A9A'
        },
        onClick: setSearch2
      }),
      inputStyle: {
        width: '325px'
      }
    },
    selectProps: {
      dropdownList: props.dropdownList1,
      itemClick: props.setSelectedFilter2,
      selectedItem: ((_props$selectedFilter2 = props.selectedFilter2) === null || _props$selectedFilter2 === void 0 ? void 0 : _props$selectedFilter2.value) || "Select",
      placeholder: "Please select filter",
      inputStyle: {
        width: '300px'
      }
    }
  }), /*#__PURE__*/_react.default.createElement(_DataTable.DataTable, {
    isReponsive: true,
    checkboxPosition: "right",
    isLoading: props.isDataLoading2,
    allowRowClick: props.allowRowClick,
    headerSchema: props.headerSchema,
    bodySchema: props.bodySchemaModal,
    handleAllRowSelected: props.setAllSelectedModal,
    allRowSelected: props.allSelectModal,
    rowSelectedList: props.rowSelectModal,
    handleRowSelect: props.setRowSelectedModal,
    paginationProps: {
      totalLength: props.countModal,
      currentPage: props.currentModalPage,
      pageSize: props.pageSizeModal,
      handlePageChange: props.handleModalPageChange,
      paginationStyle: {
        float: "right"
      }
    },
    loadingDataProps: {
      headingTitle: "Loading",
      headerDesc: "Please wait while we fetch records..."
    },
    noDataProps: {
      headingTitle: "No Results Found",
      headerDesc: "Try adjusting your search to find what you’re looking for."
    }
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: true,
    md: true,
    sm: true,
    className: "d-flex flex-row  justify-content-end  align-items-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-row align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    title: "Cancel",
    variant: "nav-link-button",
    className: "",
    buttonStyle: {
      width: 150,
      justifyContent: 'center'
    },
    onClick: setUserModal
  }), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    title: "Save",
    variant: "primary",
    className: "",
    buttonStyle: {
      width: 150,
      justifyContent: 'center',
      borderRadius: 10
    },
    onClick: handleSubmit
  }))))) : null)), isLoading && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      zIndex: 9999,
      position: "fixed",
      top: 0,
      left: 0,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexWrap: "wrap",
      flexDirection: "column",
      width: "100%",
      height: "100%",
      backdropFilter: "blur(1px)",
      background: "rgba(255,255,255,0.2)"
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border"
  })), props.displayZoomImage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "image-zoom-modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: "web-screen-zoom",
    displayModal: props.displayZoomImage,
    imageVariant: "zoom-image",
    zoomImageSrc: props.storeImage,
    displayCrossIcon: true,
    crossIconAction: props.crossIconAction
  })) : null);
};
var _default = exports.default = StoreDetailsComponent;